<ion-content [class]="outerClass">
  <div [class]="innerClass" fxLayout="column">
    <ng-content></ng-content>
  </div>
</ion-content>